<button type="button" class="leading-none inline-block transition-all relative top-[2px] hover:text-primary-500" (click)="toggleFullscreen()">
    <i class="material-symbols-outlined !text-[22px] md:!text-xl">
        {{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}
    </i>
</button>